(function () {
    'use strict';

    angular.module('d3gauge', []);
    angular.module('d3gauge')

    .directive('d3gauge', ['$timeout', 'd3gaugeService', function ($timeout, service) {
        var d = {
            restrict: 'E',
            replace: true,
            require: 'ngModel',
            scope: {
                label:'@',
                config: '=?'
            }
        };
        d.template = '<span id="{{id}}"></span>';
        d.link = function (scope, element, attr, ngModel) {
            scope.id = 'a-xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c === 'x' ? r : r&0x3|0x8;
                return v.toString(16);
            });
            var createGauge = function (label, config)
            {
                if (!config) {
                    config = {};
                }
                config.label = label;
                if (!config.size) {
                    config.size = 200;
                }
                if (!config.min) {
                    config.min = 0;
                }
                if (!config.max) {
                    config.max = 10;
                }
                var range = config.max - config.min;
                if (!config.greenZones) {
                    config.greenZones = [{ from: config.min, to: config.min + range*0.75 }];
                }
                if (!config.yellowZones) {
                    config.yellowZones = [{ from: config.min + range*0.75, to: config.min + range*0.9 }];
                }
                if (!config.redZone) {
                    config.redZones = [{ from: config.min + range*0.9, to: config.max }];
                }
                scope.gauge = new service.Gauge(scope.id, config);
            };
            var rendered = false;
            var rendering = false;
            var render = function (vv) {
                if (!rendered && !rendering) {
                    rendering = true;
                    $timeout(function () {
                        rendered = true;
                        rendering = false;
                        scope.gauge.render();
                        scope.gauge.redraw(vv);
                    }, 1000);
                } else if (!rendered && rendering) {
                    $timeout(function () {
                        scope.gauge.redraw(vv);
                    }, 1000);
                } else if (rendered && !rendering) {
                    scope.gauge.redraw(vv);
                }
            };
            createGauge(scope.label, scope.config);
            ngModel.$render = function () {
                var vv = ngModel.$viewValue;
                if (!vv) {
                    vv = 0;
                }
                render(vv);
            };
        };
        return d;
    }]);

})();
